(function ($) {
    $.fn.toggleAccess = function () {
        var $this = $(this);

        var checkToggledAll = function (element) {
            if ($(document).find('[data-service="' + element.data('toggle') + '"]').length ==
                $(document).find('[data-service="' + element.data('toggle') + '"]:checked').length) {
                element.addClass('btn-primary');
                element.data('toggled', true);
            }
            else {
                element.removeClass('btn-primary');
                element.data('toggled', false);
            }
        };

        $this.each(function () {
            var element = $(this);

            checkToggledAll(element);

            $(document).find('[data-service="' + element.data('toggle') + '"]').change(function () {
                checkToggledAll(element);
            });
        });

        this.on('click', function (event) {
            event.preventDefault();
            var element = $(event.target);
            var newState = !element.data('toggled');

            $(document).find('[data-service="' + element.data('toggle') + '"]').prop('checked', newState);
            element.data('toggled', newState);
            if (newState) {
                element.addClass('btn-primary');
            }
            else {
                element.removeClass('btn-primary');
            }
        });
    }
}(jQuery));
